import React from "react";
import { DocumentPart } from "../../api/models";
import { PageDocumentRoots } from "../../api/models/page-document-roots";

export interface FileLocation {
  key: string;
  text: string;
  iconName?: string;
  path?: string;
  document?: DocumentPart;
  readPermission?: boolean;
}

export interface FileLocationExplored {
  item: FileLocation;
  path: FileLocation[];
  children: FileLocation[];
  page?: PageDocumentRoots;
}

export interface SelectedItemLocation {
  fileLocation: FileLocation;
  fileLocationPath: string;
  fileLocationExplored: FileLocationExplored;
}

export interface FileLocationProvider {
  applicationCurrentLocation: FileLocation;
  selectApplicationCurrentLocation: (location: FileLocation) => void;
  selectItemLocation: (location: FileLocation) => void;
  selectedItemLocation: SelectedItemLocation;
  exploredLocation: FileLocationExplored;
  exploreLocation: (location: FileLocation) => void;
  updateChildren: (children: FileLocation[], page: PageDocumentRoots) => void;
}

export const FileLocationProviderContext = React.createContext<FileLocationProvider>(undefined);
